
import { defineComponent, ref, watch, PropType } from 'vue'

export default defineComponent({
  props: {
    checked: Boolean,
    modelValue: null,
    done: Function as PropType<() => void>,
  },
  setup(props, { emit }) {
    const state = ref(props.checked)
    const onClick = () => {
      if (!props.done || (props.done && props.done())) {
        state.value = !state.value
        emit('update:modelValue', state.value)
      }
    }

    watch(() => props.checked, checked => {
      state.value = checked
    })

    return {
      state,
      onClick,
    }
  }
})
